const production = process.env.NODE_ENV === "production";
// Url for main backend server
export const API_BASEURL = production
    ? process.env.REACT_APP_API_PUBLIC_URL
    : "http://localhost:3001";
